var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let AlertingResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.default, "/workspaces");
    __publicField(this, "_errorMessage", (RestResult2, response) => {
      return response && response.ExceptionMessage;
    });
  }
  loadAutoShutdown(workspaceId, stepId) {
    return __async(this, null, function* () {
      const address = `/${workspaceId}/experimentSteps/${stepId}/autoShutdown?api-version=2022-12-01-internal`;
      const result = yield this._get(address);
      return result;
    });
  }
  loadAlerts(workspaceId, stepId) {
    return __async(this, null, function* () {
      let address = `/${workspaceId}/experimentSteps/${stepId}/alerts?skip=0&api-version=2021-11-01-preview`;
      const result = yield this._get(address);
      return result;
    });
  }
};
AlertingResource = __decorateClass([
  WPSProxyConverter()
], AlertingResource);
const Alerting_resource = new AlertingResource();
export {
  Alerting_resource as default
};
//# sourceMappingURL=Alerting.resource.js.map
